import React from 'react'
import { Link } from 'react-router-dom'
import './TestPage.css'

const TestPage: React.FC = () => {
  return (
    <div className="test-page">
      <div className="test-container">
        <h1 className="test-title">Test Page</h1>
        <p className="test-description">
          This route verifies that React Router is working correctly.
        </p>
        <div className="test-info">
          <div className="info-card">
            <h3>Route</h3>
            <p><strong>Path:</strong> /test</p>
            <p><strong>Status:</strong> Active</p>
          </div>
          <div className="info-card">
            <h3>Navigation</h3>
            <Link to="/" className="nav-link">← Back to Home</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TestPage